<template>
  <div
    class="col-12 row auctions__row no-gutters"
    v-if="artwork"
    :id="`artwork_${artwork.id}`"
  >
    <ArtworkCatalogNumber :catalogNumber="artwork.catalogNumber" class="col-sm-1" />
    <ArtworkDetails
      :artwork="artwork"
      :index="index"
    />
  </div>
</template>

<script>
  import ArtworkCatalogNumber from '@/shared/components/artwork_catalog_number';
  import ArtworkDetails from './artwork_details';

  export default {
    name: 'ArtworkRow',
    props: {
      artwork: {
        type: Object,
        required: true,
      },
      index: {
        type: Number,
        required: true,
      },
    },
    components: {
      ArtworkDetails,
      ArtworkCatalogNumber,
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/auctions_catalogs/show/components/artwork/row.vue?91ca4936